export default "__VITE_ASSET__l2UMlMlh__"